// extracted by mini-css-extract-plugin
module.exports = {"Quantity":"Styles_Quantity__3t2Eq","CardRow":"Styles_CardRow__3I6BN"};